import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/my-tickets',
    name: 'MyTicketsPage',
    component: () => import('@/modules/tickets/views/TicketsPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/create-ticket',
    name: 'CreateTicketPage',
    component: () => import('@/modules/tickets/views/CreateTicketPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/create-ticket-success',
    name: 'CreateTicketSuccess',
    component: () => import('@/modules/tickets/views/CreateTicketSuccesPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/tickets/:id',
    name: 'TicketDetails',
    component: () => import('@/modules/tickets/views/TicketDetails.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
